<template>
  <b-card id="seccion-content">
    <b-card-header class="header-df">
      <b-col
        cols="12"
        md="12"
        class="pl-0"
      >
        <b-media vertical-align="center">
          <template #aside>
            <img
              src="/assets/img/d-gas.png"
              width="40"
            >
          </template>
          <span class="font-weight-bold d-block text-nowrap">
            Distribución Cilindros
          </span>
          <small class="text-muted">Lista de Productos disbribuidos en Cisternas.</small>
        </b-media>
      </b-col>
    </b-card-header>
    <b-card
      no-body
      class="mb-0"
    >
      <b-table
        class="position-relative"
        :items="items"
        responsive
        :fields="fields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No se encontraron registros"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
        </template>
        <template #cell(producto)="data">
          <b-media vertical-align="center">
            <span class="font-weight-bold d-block text-nowrap">
              {{ data.item.producto.presentacion.descripcion }}
            </span>
            <small class="text-muted d-block">{{ data.item.producto.presentacion.marca.descripcion }}</small>
          </b-media>
        </template>
        <template #cell(fechaOperacion)="data">
          <div>
            <div>
              <div class="font-small-3">
                <feather-icon icon="CalendarIcon" />
                {{ data.item.fechaOperacion }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(totalKgBruto)="data">
          <div>
            <div class="font-small-3">
              {{ data.item.totalKgBruto }}
            </div>
            <div class="font-small-3">
              {{ data.item.totalGalBruto }}
            </div>
          </div>
        </template>
        <template #cell(totalKgNeto)="data">
          <div>
            <div class="font-small-3">
              {{ data.item.totalKgNeto }}
            </div>
            <div class="font-small-3">
              {{ data.item.totalGalNeto }}
            </div>
          </div>
        </template>
        <template #cell(unidad)="">
          <div>
            <div class="font-small-3 font-weight-bold">
              KG
            </div>
            <div class="font-small-3 font-weight-bold">
              GAL
            </div>
          </div>
        </template>
        <template #cell(cantidad)="data">
          <div>
            <div class="font-small-4 font-weight-bold">
              {{ data.item.cantidad }}
            </div>
          </div>
        </template>
        <template #cell()="data">
          <span class="d-block text-nowrap text-justify">
            {{ data.value }}
          </span>
        </template>
      </b-table>
    </b-card>
  </b-card>
</template>

<script>
import {
  BTable,
  BCol,
  BCard,
  BCardHeader,
  BMedia,
  BSpinner,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BCard,
    BMedia,
    BCol,
    BCardHeader,
    BTable,
    BSpinner,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      fields: [
        { key: 'idAbastoCilindro', sortable: true, thClass: 'd-none', tdClass: 'd-none' },
        { key: 'fechaOperacion', label: 'Fecha', thClass: ['text-center'], tdClass: ['text-center'] },
        { key: 'producto', label: 'Producto', tdClass: ['text-center'], thClass: ['text-center'] },
        { key: 'totalKgBruto', label: 'Bruto', tdClass: ['text-center', 'bg-white'], thClass: ['text-center'] },
        { key: 'totalKgNeto', label: 'Neto', tdClass: ['text-center', 'bg-white'], thClass: ['text-center'] },
        { key: 'unidad', label: 'Unidad', tdClass: ['text-center', 'bg-white'], thClass: ['text-center'] },
        { key: 'cantidad', label: 'cantidad', tdClass: ['text-center', 'bg-white'], thClass: ['text-center'] },
      ],
      sortBy: null,
    }
  },
  mounted() {
  },
  methods: {
    clean() {
      this.items = []
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.header-df {
  background-color: rgba(34, 41, 47, 0.03) !important;
  border-bottom: 1px solid rgba(34, 41, 47, 0.125) !important;
}

.nav-tabs {
  background: #f6f6f6 !important;
}

.actions-bar {
  background: #f6f6f6 !important;
  justify-content: end;
}

.form-group {
  margin-bottom: 0.5rem !important;
}

#seccion-content.card > .card-body {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

#seccion-content {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
#empresa{
  width: 100% !important;
}
</style>
